import React, {Fragment} from 'react';
import connect from "react-redux/es/connect/connect";
import classNames from "classnames";
import ModalEditor from "../editors/ModalEditor";
import {loadTill} from '../../actions';
import Icon from "../form/Icon";
import Button from "../form/Button";
import Select from "../form/Select";
import isEqual from "lodash-es/isEqual";

class MainTillMenu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {till: props.till, pos: props.till.pos, isLoading: false};
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!isEqual(prevProps.till, this.props.till)) {
            this.setState({till: this.props.till, pos: this.props.till.pos});
        }
        if (!isEqual((prevProps.user || {}).id, (this.props.user || {}).id)) {
            this.editor && this.editor.hide();
        }
    }

    onClick = async (e) => {
        e && e.preventDefault();
        if (!this.props.user.hasPermission("set_pos")) {
            return;
        }
        this.setState({till: this.props.till, pos: this.props.till.pos});
        this.editor && this.editor.focus();
    }

    saveForm = async (e) => {
        e && e.preventDefault();
        this.setState({isLoading: true}, async () => {
            await this.props.loadTill(this.state.till.id);
            this.editor && this.editor.hide();
            this.setState({isLoading: false});
        });
    }

    render() {
        let posFilter = null;
        if (this.props.user.partner) {
            posFilter = [{field: "partner", value: this.props.user.partner.partner_id}];
        }
        return <Fragment>
            <li>
                <a {...{href: !this.props.user.hasPermission("set_pos") ? null : "#"}} onClick={this.onClick}>
                    <Icon lib="fas" name="store-alt" tooltip="Eladás helye" /> {this.props.till.pos && this.props.till.pos.name && <span>{this.props.till.pos.name} <span className="till"> <Icon lib="fa" name="cash-register" tooltip="Pénztár" /> {this.props.till.id ? this.props.till.displayname : null}</span></span>}
                    {!this.props.till.id && <span className="label label-danger">!</span>}
                </a>
            </li>
            <ModalEditor
                {...this.props}
                isLoading={this.state.isLoading}
                pristineForm={() => {
                    this.editor && this.editor.hide();
                }}
                size={"medium"}
                ref={(editor) => this.editor = editor}
                theme="default"
                header={"Eladási hely"}
                footer={[
                    <Button
                        key="0"
                        color="primary"
                        className="pull-right"
                        disabled={!(this.state.till || {}).id || isEqual((this.props.till || {}).id, (this.state.till || {}).id) || this.state.isLoading || !this.props.user.hasPermission("set_pos")}
                        onClick={this.saveForm}
                    >
                        Bejelentkezés
                    </Button>
                ]}
            >
                <div className="row form-row">
                    <div className="col-md-6">
                        <Select
                            objectValue={true}
                            disabled={this.state.isLoading || !this.props.user.hasPermission("set_pos")}
                            name="pos"
                            component="PointOfSale"
                            labelKey="name"
                            valueKey="id"
                            filter={posFilter}
                            storeType="local"
                            value={this.state.pos}
                            saveChanges={(field, pos) => this.setState({pos, till: null})}
                            label={<Fragment><Icon lib="fas" name="store-alt" /> Eladás helye</Fragment>}
                        />
                    </div>
                    <div className="col-md-6">
                        {
                            (this.state.pos || {}).id &&
                            <Select
                                filter={[{field: "pos", value: (this.state.pos || {}).id || null}]}
                                autoSelect={true}
                                objectValue={true}
                                disabled={this.state.isLoading || !this.props.user.hasPermission("set_pos")}
                                name="till"
                                component="Till"
                                labelKey="displayname"
                                valueKey="id"
                                storeType="local"
                                value={this.state.till}
                                saveChanges={(field, till) => this.setState({till})}
                                label={<Fragment><Icon lib="fa" name="cash-register" /> Pénztár</Fragment>}
                            />
                        }
                    </div>
                </div>
            </ModalEditor>
        </Fragment>;
    }
}

const ConnectedMainTillMenu = connect((state) => {return {till: state.app.till,user: state.app.user}}, {loadTill})(MainTillMenu);

export default ConnectedMainTillMenu;